<template>
  <div>
    <v-dialog v-model="dialogdetailuser" persistent transition="none" fullscreen>
      <v-card class="pa-0" style="overflow-y:auto; height:90vh; display:flex; flex-direction:column;">
        <div style="background: #003871; width: 100%; text-align: center; padding: 16px 0; position: relative;">
          <span class="text-h6" style="margin:0; font-weight:700; color:white !important;">
            Setup Detail KPI
          </span>
          <!-- <span class="text-white text-h6" style="margin:0; font-weight:700;">Setup Detail KPI</span><v-icon class="text-white" size="25" style="margin-right: 16px; margin-left: 15px; margin-bottom: 7px;">mdi-wrench</v-icon> -->
          <v-btn icon small @click="dialogdetailuser = false" style="position:absolute; top:8px; right:8px; color:white;">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="px-6 pb-6">
          <!-- Header Card dengan Button di satu baris -->
          <div class="d-flex align-center justify-space-between mb-4 mt-6">
            <!-- Simplified Prepared by Card -->
            <div class="kpi-header-card-simplified">
              <div class="d-flex align-center">
                <v-icon color="primary" size="20" class="mr-2">mdi-account-circle</v-icon>
                <div>
                  <span class="kpi-prepared-label-simplified">Prepared by:</span>
                  <span class="kpi-info-value-simplified ml-2">{{ preparedByName }} - {{ preparedByPosition }}</span>
                </div>
              </div>
            </div>
            
            <!-- Add Item KPI Button -->
            <v-btn 
              color="success" 
              medium 
              @click="emitAddKpiData"
              class="kpi-add-btn"
            >
              <v-icon left>mdi-plus</v-icon>
              Add Item KPI
            </v-btn>
          </div>
          <div class="kpi-table-container">
            <v-simple-table fixed-header height="70vh" dense class="kpi-table">
                <thead>
                  <tr>
                    <th class="text-center text-white">No</th>
                    <th class="text-center text-white">Adjustment</th>
                    <th class="text-center text-white">Accounting</th>
                    <th class="text-center text-white">KPI Name</th>
                    <th class="text-center text-white min-w-250">Owner</th>
                    <th class="text-center text-white min-w-350">Sharing</th>
                    <th class="text-center text-white min-w-150">Pengukuran</th>
                    <th class="text-center text-white min-w-150">Sumber Data</th>
                    <th class="text-center text-white min-w-100">Unit</th>
                    <th class="text-center text-white min-w-100">Kalkulasi</th>
                    <th class="text-center text-white min-w-150">Vertikal</th>
                    <th class="text-center text-white">Bobot</th>
                    <th class="text-center text-white">Annual Target</th>
                    <th class="text-center text-white">Higher/Lower Better</th>
                    <th class="text-center text-white">Action</th>
                  </tr>
                </thead>
              <tbody>
              <template v-for="(kpi, kpiIndex) in kpiData">
                    <tr :key="`${kpiIndex}-main`" v-if="kpi.ownerSets && kpi.ownerSets.length > 0">
                      <td class="align-center text-body-1" style="vertical-align: middle !important;">
                        {{ kpi.nomor || (kpiIndex + 1) }}
                      </td>
                      <td class="align-center">
                        <v-checkbox 
                          v-model="kpi.ownerSets[0].checked"  
                          @change="trackChanges(kpi, 'manual_adjustment', $event)" 
                          :disabled="isFieldDisabledForShared(kpi, 'kpi_name') || IsChildParent(kpi) || isDisabledChildDisplay(kpi)"
                          dense hide-details class="checkbox-center"
                        />
                      </td>
                      <td class="align-center">
                        <v-checkbox 
                          v-model="kpi.ownerSets[0].isAccounting" 
                          @change="trackChanges(kpi, 'is_accounting', $event)" 
                          :disabled="isFieldDisabledForShared(kpi, 'kpi_name') || IsChildParent(kpi) || isDisabledChildDisplay(kpi)"
                          dense hide-details class="checkbox-center"
                        />
                      </td>
                      <td class="merged-cell" style="min-width: 400px;">
                        <v-textarea 
                          :disabled="isFieldDisabledForShared(kpi, 'kpi_name') || isDisabledChildDisplay(kpi) || IsChildParent(kpi)"
                          v-model="kpi.kpiName" 
                          @input="trackChanges(kpi, 'kpi_name', $event)"
                          outlined hide-details class="input-center"
                          auto-grow
                          rows="2"
                          @keydown.enter.prevent
                        />
						<!-- validation for empty kpi_name -->
						<div v-if="kpi.kpiName === null || String(kpi.kpiName).trim() == ''" class="error-message-wrapper">
							<v-icon small color="error" class="mr-1">mdi-alert-circle</v-icon>
							<span class="error-message-text">KPI Name tidak boleh kosong</span>
						</div>
                      </td>
                      <td class="align-center table-input-small">
                            <v-text-field 
                              v-if="isSharedKpi(kpi)"
                              :value="getSharedOwnerDisplay(kpi)"
                              readonly
                              dense 
                              disabled
                              outlined 
                              hide-details 
                              class="input-center"
                              placeholder="Shared Owner"
                            />
                            <v-select 
                              v-else
                              :items="owners" 
                              :disabled="isFieldDisabledForShared(kpi, 'owner') || isNewItem(kpi) || isDisabledChildDisplay(kpi) || isOwned(kpi) || parentDisabled(kpi) || IsChildParent(kpi)"
                              v-model="kpi.ownerSets[0].owner" 
                              @change="trackChanges(kpi, 'owner_id', $event)" 
                              dense outlined hide-details 
                              class="input-center"
                            />
							<!-- validation for empty owner -->
							<div v-if="kpi.ownerSets[0].owner === null || String(kpi.ownerSets[0].owner).trim() == ''" class="error-message-wrapper">
								<v-icon small color="error" class="mr-1">mdi-alert-circle</v-icon>
								<span class="error-message-text">Owner tidak boleh kosong</span>
							</div>
                      </td>
                      <td class="align-center" style="max-width: 400px;">
                          <v-text-field 
                            v-if="isSharedKpi(kpi)"
                            :value="getSharingDisplayText(kpi)"
                            readonly
                            dense 
                            disabled
                            outlined 
                            hide-details 
                            class="input-center"
                            placeholder="Shared KPI"
                          />
                          <v-combobox
                            v-else
                            v-model="kpi.ownerSets[0].sharing"
                            :items="sharingOptions"
                            item-text="text"
                            item-value="value"
                            multiple
                            chips
                            :disabled="isFieldDisabledForShared(kpi, 'owner')"
                            small-chips
                            deletable-chips
                            dense
                            outlined
                            hide-details
                            class="input-center"
                            @change="trackChanges(kpi, 'sharing', $event)"
                          >
                            <template v-slot:selection="{ item, index }">
                              <v-chip
                                small
                                close
                                @click:close="removeChip(kpi, item, index)"
                              >
                                {{ item.text || getSharingName(item) }}
                              </v-chip>
                            </template>
                          </v-combobox>
                      </td>
                      <td class="align-center" style="min-width: 400px;">
                        <v-textarea
                          v-model="kpi.ownerSets[0].pengukuran" 
                          @input="trackChanges(kpi, 'pengukuran', $event)" 
                          :disabled="isFieldDisabledForShared(kpi, 'pengukuran') || isDisabledChildDisplay(kpi) || IsChildParent(kpi)"
                          dense outlined hide-details class="input-center"
						  auto-grow
                          rows="2"
                        />
						<!-- validation for empty pengukuran -->
						<div v-if="kpi.ownerSets[0].pengukuran === null || String(kpi.ownerSets[0].pengukuran).trim() == ''" class="error-message-wrapper">
							<v-icon small color="error" class="mr-1">mdi-alert-circle</v-icon>
							<span class="error-message-text">Pengukuran tidak boleh kosong</span>
						</div>
                      </td>
                      <td class="align-center" style="min-width: 400px;">
                        <v-textarea
                          :disabled="isFieldDisabledForShared(kpi, 'sumber_data') || isDisabledChildDisplay(kpi) || IsChildParent(kpi)"
                          v-model="kpi.ownerSets[0].sumberData" 
                          @input="trackChanges(kpi, 'sumber_data', $event)" 
                          dense outlined hide-details class="input-center"
						  auto-grow
                          rows="2"
                        />
                      </td>
                      <td class="merged-cell">
                        <v-select
                         :disabled="isFieldDisabledForShared(kpi, 'unit') ||isDisabledChildDisplay(kpi) || IsChildParent(kpi)"
                          v-model="kpi.unit"
                          :items="['%', 'Rp', 'Unit']"
                          @change="trackChanges(kpi, 'unit_id', getUnitId($event))"
                          dense outlined hide-details class="input-center"
                        />
						<!-- validation for empty unit -->
						<div v-if="kpi.unit === null || String(kpi.unit).trim() == ''" class="error-message-wrapper">
							<v-icon small color="error" class="mr-1">mdi-alert-circle</v-icon>
							<span class="error-message-text">Unit tidak boleh kosong</span>
						</div>
                      </td>
                      <td class="merged-cell">
                        <v-select 
                          :items="calcOptions" 
                          :disabled="isFieldDisabledForShared(kpi, 'unit') || isDisabledChildDisplay(kpi) || IsChildParent(kpi)"
                          v-model="kpi.kalkulasi" 
                          @change="trackChanges(kpi, 'kalkulasi_id', getCalculationId($event))" 
                          dense outlined hide-details class="input-center"
                        />
						<!-- validation for empty kalkulasi -->
						<div v-if="kpi.kalkulasi === null || String(kpi.kalkulasi).trim() == ''" class="error-message-wrapper">
							<v-icon small color="error" class="mr-1">mdi-alert-circle</v-icon>
							<span class="error-message-text">Kalkulasi tidak boleh kosong</span>
						</div>
                      </td>
                       <td class="merged-cell">
                        <v-select 
                          v-model="kpi.vertikal"
                          :items="verOptions" 
                          @input="trackChanges(kpi, 'vertikal', $event)" 
                          :disabled="isFieldDisabledForShared(kpi, 'vertikal') || isDisabledChildDisplay(kpi) || !isVertikalEnabled(kpi) || IsChildParent(kpi) || isAjusment(kpi)"
                          :placeholder="!isVertikalEnabled(kpi) || isFieldDisabledForShared(kpi, 'vertikal') || IsChildParent(kpi) || isAjusment(kpi) ? 'Disabled' : ''"
                          dense outlined hide-details class="input-center"
                          clearable
                          :class="{ 'disabled-field': !isVertikalEnabled(kpi) }"
                        />
                      </td>
                      <td class="merged-cell">
                        <v-text-field 
                          v-model="kpi.bobot"
                          type="number"
                          min="0"
                          max="100"
                          @input="trackChanges(kpi, 'bobot', $event)" 
                          dense outlined hide-details class="input-center"
                        />
						<!-- validation for empty bobot -->
						<div v-if="kpi.bobot === null || String(kpi.bobot).trim() == ''" class="error-message-wrapper">
							<v-icon small color="error" class="mr-1">mdi-alert-circle</v-icon>
							<span class="error-message-text">Bobot tidak boleh kosong</span>
						</div>
                      </td>
                      <td class="align-center">
                        <v-text-field 
                          :value="formatThousandId(kpi.ownerSets[0].annualTarget)" 
                          @input="trackChanges(kpi, 'annual_target', $event)"
                          :disabled="!isOwned(kpi) && (isFieldDisabledForShared(kpi, 'annual_target') || !isAnnualTargetEnabled(kpi) || isDisabledChildDisplay(kpi) || isSharedKpi(kpi))"
                          dense outlined hide-details class="input-center"
                        />
						<!-- validation for empty annual target -->
						<div v-if="kpi.ownerSets[0].annualTarget === null || String(kpi.ownerSets[0].annualTarget).trim() == ''" class="error-message-wrapper">
							<v-icon small color="error" class="mr-1">mdi-alert-circle</v-icon>
							<span class="error-message-text">Annual Target tidak boleh kosong</span>
						</div>
                      </td>
                      <td class="align-center">
                        <v-select 
                          :items="higherLowerOptions" 
                           :disabled="isFieldDisabledForShared(kpi, 'direction') || isDisabledChildDisplay(kpi) || IsChildParent(kpi)"
                          v-model="kpi.ownerSets[0].higherLower" 
                          @change="trackChanges(kpi, 'direction', $event)" 
                          dense outlined hide-details class="input-center"
                        />
						<!-- validation for empty higher lower -->
						<div v-if="kpi.ownerSets[0].higherLower === null || String(kpi.ownerSets[0].higherLower).trim() == ''" class="error-message-wrapper">
							<v-icon small color="error" class="mr-1">mdi-alert-circle</v-icon>
							<span class="error-message-text">Higher Lower tidak boleh kosong</span>
						</div>
                      </td>
                    <!-- <td class="align-center action-buttons">
                      <div class="d-flex align-center justify-center">
                        <v-btn small icon color="success" class="mr-1" @click="addOwnerSetLocal(kpiIndex)">
                          <v-icon small>mdi-plus</v-icon>
                        </v-btn>
                         <v-btn small icon color="error" @click="removeallkpi(kpiIndex)">
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </div>
                    </td> -->
                      <!-- <div style="font-size: 10px; color: red; margin-bottom: 5px;">
                        ID: {{ kpi.id }} | Status: {{ kpi.status_kpi }} | 
                        isShared: {{ isSharedKpi(kpi) }} | 
                        isChild: {{ isDisabledChildDisplay(kpi) }}
                      </div> -->
                    <td class="align-center action-buttons">
                      <div class="d-flex align-center justify-end">
                            <template v-if="!isSharedKpi(kpi) && !isDisabledChildDisplay(kpi)">
                            <v-chip v-if="IsChildParent(kpi)" small color="purple" text-color="white">
                              <v-icon small left>mdi-source-branch</v-icon>
                              Child-Parent
                            </v-chip>
                          
                            <v-btn small icon color="success" class="mr-1" @click="addOwnerSetLocal(kpiIndex)">
                              <v-icon small>mdi-plus</v-icon>
                            </v-btn>
                             <v-btn v-if="!IsChildParent(kpi)" small icon color="error" @click="removeallkpi(kpiIndex)">
                           
                              <v-icon small>mdi-delete</v-icon>
                            </v-btn>
                          
                          </template>
                      <template v-else-if="isSharedKpi(kpi)">
                        <v-chip small color="warning" text-color="white">
                          <v-icon small left>mdi-share</v-icon>
                          KPI Shared
                        </v-chip>
                      </template>
                      <template v-else-if="isDisabledChildDisplay(kpi)">
                        <v-chip small color="info" text-color="white">
                          <v-icon small left>mdi-account-child</v-icon>
                          KPI Child
                        </v-chip>
                        <div class="d-flex align-center justify-end">
                        <v-btn small icon color="success" class="mr-1" @click="addOwnerSetLocal(kpiIndex)">
                          <v-icon small>mdi-plus</v-icon>
                        </v-btn>
                      </div>
                      </template>
                    </div>
                    </td>
                    </tr>
                    <template v-if="kpi.ownerSets.length > 1">
                      <tr v-for="(ownerSet, ownerSetIndex) in kpi.ownerSets.slice(1)" :key="`${kpiIndex}-${ownerSetIndex}`" > <!--class="additional-row"-->
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td class="align-center table-input-small">
                          <v-select 
                            :items="owners" 
                            v-model="ownerSet.owner" 
                            @change="trackOwnerSetChanges(kpi, ownerSetIndex + 1, 'owner_id', $event)"
                            dense outlined hide-details 
                            class="input-center"
                          />
						  <!-- validation -->
						  <div v-if="ownerSet.owner === null || String(ownerSet.owner).trim() == ''" class="error-message-wrapper">
							<v-icon small color="error" class="mr-1">mdi-alert-circle</v-icon>
							<span class="error-message-text">KPI Name tidak boleh kosong</span>
						</div>
                        </td>
                        <td class="align-center">
                            <v-combobox
                              v-model="ownerSet.sharing"
                              :items="sharingOptions"
                              item-text="text"
                              item-value="value"
                              multiple
                              chips
                              :disabled="isFieldDisabledForShared(kpi, 'owner')"
                              small-chips
                              deletable-chips
                              dense
                              outlined
                              hide-details
                              class="input-center"
                              @change="trackOwnerSetChanges(kpi, ownerSetIndex + 1, 'sharing_id', $event)"
                            >
                              <template v-slot:selection="{ item, index }">
                                <v-chip
                                  small
                                  close
                                  @click:close="removeChildChip(kpi, item, index, ownerSetIndex + 1)"
                                >
                                  {{ item.text || getSharingNameChild(item) }}
                                </v-chip>
                              </template>
                            </v-combobox>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td class="align-center"> 
                          <v-text-field 
							:value="formatThousandId(ownerSet.annualTarget)" 
                            @input="trackOwnerSetChanges(kpi, ownerSetIndex + 1, 'annual_target', $event)" 
                            dense
                            :disabled="isSharedKpi(kpi)"
                            outlined 
                            hide-details 
                            class="input-center" 
                          /> 
						  <!-- validation -->
						  <div v-if="ownerSet.annualTarget === null || String(ownerSet.annualTarget).trim() == ''" class="error-message-wrapper">
							<v-icon small color="error" class="mr-1">mdi-alert-circle</v-icon>
							<span class="error-message-text">Annual Target tidak boleh kosong</span>
						  </div>
                        </td>
                        <td class="align-center">
                          <v-select :items="higherLowerOptions" v-model="ownerSet.higherLower" dense disabled outlined hide-details class="input-center"/>
                        </td>
                      <td class="align-center action-buttons">
                        <div class="d-flex align-center justify-end">
                          <v-btn small icon color="error" @click="removeOwnerSetLocal({ kpiIndex, ownerSetIndex: ownerSetIndex + 1 })">
                            <v-icon small>mdi-delete</v-icon>
                          </v-btn>
                        </div>
                      </td>
                      </tr>
                    </template>
              </template>
              </tbody>
            </v-simple-table>
          </div>
        </v-card-text>
      </v-card>
      <v-card-actions class="d-flex justify-space-between align-center pa-6 sticky-footer" style="background-color: #e2eefb;">
        <div class="kpi-note-text">
          NB : TOTAL BOBOT HARUS 100 UNTUK PROSES SELANJUT NYA
        </div>
        <div class="d-flex align-center">
          <v-chip class="mr-4" :color="calculateTotalBobot == 100 ? 'green' : 'grey lighten-2'" label>Total Bobot: {{ calculateTotalBobot }} / 100</v-chip>
          <v-btn
            medium
            color="primary"
            class="d-flex justify-space-between align-center mr-2"
            style="width: 130px; padding-right: 10px;"
            @click="batchSaveKpiData"
            :loading="isSaving"
          >
            <span class="mx-auto">Save</span>
            <v-icon>mdi-content-save</v-icon>
          </v-btn>
          <v-btn
            medium
            color="success"
            class="d-flex justify-space-between align-center"
            style="width: 130px; padding-left: 10px;"
            v-if="ShowNextButton"
            @click="validateAndOpenSubDetail" 
          >
            <span class="mx-auto">Next</span>
            <v-icon>mdi-arrow-right-bold</v-icon>
          </v-btn>
        </div>
      </v-card-actions>
    </v-dialog>
    <v-dialog v-model="deleteConfirmDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline red--text">
          <v-icon color="red" class="mr-2">mdi-alert-circle</v-icon>
          Konfirmasi Hapus
        </v-card-title>
        <v-card-text class="pt-4">
          <div class="text-body-1">
            Apakah Anda yakin ingin menghapus Child Ini ?
          </div>    
          <div class="mt-3 text-caption red--text">
            <v-icon small color="red" class="mr-1">mdi-information</v-icon>
            Tindakan ini tidak dapat dibatalkan.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn 
            color="grey" 
            text 
            @click="cancelDeleteOwnerSet"
            >
            <v-icon left>mdi-close</v-icon>
            Batal
          </v-btn>
          <v-btn 
            color="red"
            class="text-white"
            @click="confirmDeleteOwnerSet"
            >
            <v-icon left>mdi-delete</v-icon>
            Hapus
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
	props: {
		value: Boolean,
		kpiData: {
			type: Array,
			required: true,
		},
		selectedPeriod: {
			type: Object,
			default: null,
		},
		owners: {
			type: Array,
			required: true,
		},
		sharingOptions: {
			type: Array,
			required: true,
		},
		calcOptions: {
			type: Array,
			required: true,
		},
		verOptions: {
			type: Array,
			required: true,
		},
		higherLowerOptions: {
			type: Array,
			required: true,
		},
		selectedNode: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			yearList: Array.from(
				{ length: 10 },
				(_, i) => new Date().getFullYear() - 5 + i
			),
			year: "",
			picker: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
				.toISOString()
				.substr(0, 10),
			menu: false,
			date_from: "",
			modal: false,
			date_to: "",
			isInitialLoading: false,
			hasUserInteraction: false,
			modal_to: false,
			apiOwners: [],
			apiSharingOptions: [],
			localKpiData: [],
			formattedOwners: [],
			viewMode: "",
			formattedSharingOptions: [],
			NextDialog: false,
			confirmNext: false,
			isModalJustOpened: true,
			deleteConfirmDialog: false,
			deleteOwnerSetData: null,
			changedItems: [],
			isSaving: false,
		};
	},
	async mounted() {
		this.changedItems = [];
		if (this.selectedNode?.id) {
			await this.loadSharingOptions(this.selectedNode.id);
		}
	},
	computed: {
		isGetMode() {
			return this.$route.query.mode === "get" || this.viewMode === "get";
		},
		dialogdetailuser: {
			get() {
				return this.value;
			},
			set(val) {
				if (val) {
					this.changedItems = [];
				}
				this.$emit("input", val);
			},
		},

		calculateTotalBobot() {
			return this.kpiData.reduce((total, kpi) => {
				return total + (parseInt(kpi.bobot) || 0);
			}, 0);
		},

		activePeriod() {
			if (this.selectedPeriod) {
				return this.selectedPeriod;
			}

			if (
				!this.selectedNode?.kpi_periode ||
				!Array.isArray(this.selectedNode.kpi_periode)
			) {
				return null;
			}

			const activePeriod =
				this.selectedNode.kpi_periode.find(
					(period) => period.status === "active"
				) || this.selectedNode.kpi_periode[0];

			return activePeriod;
		},

		periodStartMonth() {
			if (!this.activePeriod?.start_month) {
				return "";
			}

			const startValue = this.activePeriod.start_month;

			return startValue;
		},

		periodEndMonth() {
			if (!this.activePeriod?.end_month) {
				return "";
			}

			const endValue = this.activePeriod.end_month;

			return endValue;
		},

		hasMultipleOwnerSets() {
			return this.kpiData.some(
				(kpi) => kpi.ownerSets && kpi.ownerSets.length > 1
			);
		},

		preparedByName() {
			return this.selectedNode?.title || this.selectedNode?.user?.name || "N/A";
		},

		preparedByPosition() {
			return (
				this.selectedNode?.name || this.selectedNode?.position_name || "N/A"
			);
		},

		ShowNextButton() {
			// validation for each rows, should be the same with validation on the table
			let resultValidation = true;
			this.kpiData.forEach((kpi) => {
				if (kpi.kpiName === null || String(kpi.kpiName).trim() == "") {
					resultValidation = false;
					return;
				}
				if (
					kpi.ownerSets[0].owner === null ||
					String(kpi.ownerSets[0].owner).trim() == ""
				) {
					resultValidation = false;
					return;
				}
				if (
					kpi.ownerSets[0].pengukuran === null ||
					String(kpi.ownerSets[0].pengukuran).trim() == ""
				) {
					resultValidation = false;
					return;
				}
				if (kpi.unit === null || String(kpi.unit).trim() == "") {
					resultValidation = false;
					return;
				}
				if (kpi.kalkulasi === null || String(kpi.kalkulasi).trim() == "") {
					resultValidation = false;
					return;
				}
				if (kpi.bobot === null || String(kpi.bobot).trim() == "") {
					resultValidation = false;
					return;
				}
				if (
					kpi.ownerSets[0].annualTarget === null ||
					String(kpi.ownerSets[0].annualTarget).trim() == ""
				) {
					resultValidation = false;
					return;
				}
				if (
					kpi.ownerSets[0].higherLower === null ||
					String(kpi.ownerSets[0].higherLower).trim() == ""
				) {
					resultValidation = false;
					return;
				}
			});

			const hasUnsavedChanges = this.changedItems.length > 0;
			const isBobotComplete = this.calculateTotalBobot === 100;
			const isCurrentlySaving = this.isSaving;
			const isModalReady = !this.isModalJustOpened;

			if (
				this.isModalJustOpened &&
				this.calculateTotalBobot === 100 &&
				!hasUnsavedChanges &&
				resultValidation
			) {
				return true;
			}

			return (
				!hasUnsavedChanges &&
				isBobotComplete &&
				!isCurrentlySaving &&
				isModalReady &&
				resultValidation
			);
		},

		changedItemsCount() {
			return this.changedItems.length;
		},

		isSaveDisabled() {
			const noUserInteraction = !this.hasUserInteraction;
			const noChanges = this.changedItemsCount === 0;
			const isSaving = this.isSaving;
			return noUserInteraction || noChanges || isSaving;
		},
	},

	methods: {
		normalizeNumberInput(value) {
			// null / undefined
			if (value === null || value === undefined) return null;

			// already number
			if (typeof value === "number") return value;

			// handle string type
			if (typeof value === "string") {
				let s = String(value).trim();

				// empty string
				if (s === "") return null;

				// allow single "-" as in-progress negative input
				if (s === "-") return null;

				// remove thousand separators "," before parsing
				s = s.replace(/,/g, "");

				// only allow: optional "-", digits, optional single decimal "."
				if (!/^-?\d*\.?\d*$/.test(s)) return null;

				const num = parseFloat(s);
				return Number.isNaN(num) ? null : num;
			}

			return null;
		},

		formatThousandId(value) {
			const num =
				typeof value === "number" ? value : this.normalizeNumberInput(value);

			if (num === null || Number.isNaN(num)) return "";

			// format with comma as thousand separator
			return new Intl.NumberFormat("en-US", {
				maximumFractionDigits: 2,
			}).format(num);
		},

		isVertikalEnabled(kpi) {
			return kpi.ownerSets && kpi.ownerSets.length > 1;
		},

		IsChildParent(kpi) {
			return !!(kpi && kpi.status_kpi === "child-parent");
		},

		isAjusment(kpi) {
			return kpi.manualAdjustment === true;
		},

		isAnnualTargetEnabled(kpi) {
			if (kpi && kpi.status_kpi === "child-parent") {
				return false;
			}

			const isManualAdjustment =
				kpi.manualAdjustment === true ||
				(kpi.ownerSets &&
					kpi.ownerSets[0] &&
					kpi.ownerSets[0].checked === true) ||
				(kpi.ownerSets &&
					kpi.ownerSets[0] &&
					kpi.ownerSets[0].manual_adjustment === true);

			if (isManualAdjustment) {
				return true;
			}

			const isParentKpi = kpi.status_kpi === "parent";
			const hasMultipleOwners = kpi.ownerSets && kpi.ownerSets.length > 1;

			return !isParentKpi && !hasMultipleOwners;
		},

		trackChanges(kpi, fieldName, value) {
			if (this.isInitialLoading) {
				return;
			}
			this.hasUserInteraction = true;

			switch (fieldName) {
				case "manual_adjustment":
					kpi.ownerSets[0].checked = value;

					kpi.manualAdjustment = value;

					kpi.ownerSets.forEach((ownerSet) => {
						ownerSet.checked = value;
						ownerSet.manual_adjustment = value;
					});
					break;
				case "is_accounting":
					kpi.ownerSets[0].is_accounting = value;
					kpi.is_accounting = value;
					kpi.ownerSets.forEach((ownerSet) => {
						ownerSet.is_accounting = value;
					});
					break;
				case "kpi_name":
					kpi.kpiName = value;
					break;
				case "owner_id":
					kpi.ownerSets[0].owner = value;
					break;
				case "sharing_id":
					kpi.ownerSets[0].sharing = value;
					break;
				case "pengukuran":
					kpi.ownerSets[0].pengukuran = value;
					break;
				case "sumber_data":
					kpi.ownerSets[0].sumberData = value;
					break;
				case "unit_id":
					kpi.unit = this.getUnitText(value);
					break;
				case "kalkulasi_id":
					kpi.kalkulasi = this.getCalculationText(value);
					break;
				case "bobot":
					kpi.bobot = parseInt(value) || 0;
					break;
				case "annual_target":
					kpi.ownerSets[0].annualTarget = value;
					break;
				case "direction":
					kpi.ownerSets[0].higherLower = value;
					kpi.ownerSets.forEach((ownerSet) => {
						ownerSet.higherLower = value;
					});
					break;
				case "vertikal": {
					this.$set(kpi, "vertikal", value);

					this.$nextTick(() => {
						this.calculateAnnualTarget(kpi);
					});
					break;
				}
			}
			if (!this.changedItems.includes(kpi.id)) {
				this.changedItems.push(kpi.id);
			}
		},

		trackOwnerSetChanges(parentKpi, ownerSetIndex, fieldName, value) {
			const ownerSet = parentKpi.ownerSets[ownerSetIndex];
			if (!ownerSet) return;
			this.hasUserInteraction = true;
			switch (fieldName) {
				case "checked":
					ownerSet.checked = value;
					break;
				case "kpiName":
					ownerSet.kpiName = value;
					break;
				case "owner_id":
					ownerSet.owner = value;
					break;
				case "sharing_id":
					ownerSet.sharing = value;
					break;
				case "pengukuran":
					ownerSet.pengukuran = value;
					break;
				case "sumber_data":
					ownerSet.sumberData = value;
					break;
				case "bobot":
					ownerSet.bobot = value;
					break;
				case "annual_target":
					ownerSet.annualTarget = value;
					break;
				case "direction":
					ownerSet.higherLower = value;
					break;
			}

			ownerSet.hasChanges = true;
			if (
				ownerSet.kpi_item_id &&
				!this.changedItems.includes(ownerSet.kpi_item_id)
			) {
				this.changedItems.push(ownerSet.kpi_item_id);
			}

			if (parentKpi.id && !this.changedItems.includes(parentKpi.id)) {
				this.changedItems.push(parentKpi.id);
			}
		},

		trackFieldChange(kpi, fieldName, value) {
			switch (fieldName) {
				case "checked":
					kpi.ownerSets[0].checked = value;
					break;
				case "kpiName":
					kpi.kpiName = value;
					kpi.ownerSets[0].kpiName = value;
					break;
				case "owner":
					kpi.ownerSets[0].owner = value;
					break;
				case "sharing":
					kpi.ownerSets[0].sharing = value;
					break;
				case "pengukuran":
					kpi.ownerSets[0].pengukuran = value;
					break;
				case "sumberData":
					kpi.ownerSets[0].sumberData = value;
					break;
				case "unit":
					kpi.unit = value;
					break;
				case "kalkulasi":
					kpi.kalkulasi = value;
					break;
				case "bobot":
					kpi.bobot = value;
					break;
				case "annualTarget":
					kpi.ownerSets[0].annualTarget = value;
					break;
				case "higherLower":
					kpi.ownerSets[0].higherLower = value;
					break;
			}

			if (kpi.id && !this.changedItems.includes(kpi.id)) {
				this.changedItems.push(kpi.id);
			}
			if (kpi.ownerSets && kpi.ownerSets.length > 1) {
				for (let i = 1; i < kpi.ownerSets.length; i++) {
					const childOwnerSet = kpi.ownerSets[i];
					if (
						childOwnerSet.kpi_item_id &&
						!this.changedItems.includes(childOwnerSet.kpi_item_id)
					) {
						this.changedItems.push(childOwnerSet.kpi_item_id);
					}
				}
			}
		},

		updateChildField(parentKpi, ownerSetIndex, fieldName, value) {
			const ownerSet = parentKpi.ownerSets[ownerSetIndex];
			if (!ownerSet) return;
			this.hasUserInteraction = true;
			switch (fieldName) {
				case "checked":
					ownerSet.checked = value;
					break;
				case "kpiName":
					ownerSet.kpiName = value;
					break;
				case "owner":
					ownerSet.owner = value;
					break;
				case "sharing":
					ownerSet.sharing = value;
					break;
				case "pengukuran":
					ownerSet.pengukuran = value;
					break;
				case "sumberData":
					ownerSet.sumberData = value;
					break;
				case "annualTarget":
					ownerSet.annualTarget = value;
					break;
				case "higherLower":
					ownerSet.higherLower = value;
					break;
			}

			if (
				ownerSet.kpi_item_id &&
				!this.changedItems.includes(ownerSet.kpi_item_id)
			) {
				this.changedItems.push(ownerSet.kpi_item_id);
			}

			if (parentKpi.id && !this.changedItems.includes(parentKpi.id)) {
				this.changedItems.push(parentKpi.id);
			}

			console.log("🔥 updateChildField result:", {
				changedItemsAfter: Array.from(this.changedItems),
				changedItemsCount: this.changedItemsCount,
			});
		},

		getOwnerSetFieldName(field) {
			const fieldMap = {
				kpi_name: "kpiName",
				unit_id: "unit",
				vertical_id: "vertical",
				bobot: "bobot",
			};
			return fieldMap[field] || field;
		},

		trackChildChanges(parentKpi, childIndex, fieldName, value) {
			const child = parentKpi.children[childIndex];
			if (!child) return;
			switch (fieldName) {
				case "manual_adjustment":
					child.manual_adjustment = value;
					break;
				case "kpi_name":
					child.kpi_name = value;
					break;
				case "owner_id":
					child.owner_id = value;
					break;
				case "sharing_id":
					child.sharing_id = value;
					break;
				case "pengukuran":
					child.pengukuran = value;
					break;
				case "sumber_data":
					child.sumber_data = value;
					break;
				case "unit_id":
					child.unit_id = value;
					break;
				case "kalkulasi_id":
					child.kalkulasi_id = value;
					break;
				case "bobot":
					child.bobot = value;
					break;
				case "annual_target":
					child.annual_target = value;
					break;
				case "direction":
					child.direction = value;
					break;
			}
			if (child.id && !this.changedItems.includes(child.id)) {
				this.changedItems.push(child.id);
			}
		},

		getChildFieldName(parentFieldName) {
			const fieldMap = {
				kpi_name: "kpiName",
				unit_id: "unit",
				bobot: "bobot",
				vertical_id: "vertical",
			};
			return fieldMap[parentFieldName] || parentFieldName;
		},

		async saveKpiItem(kpi, fieldName, value) {
			try {
				if (!kpi.id) {
					return;
				}
				this.$store.dispatch("setOverlay", true);

				const formData = new FormData();
				formData.append(fieldName, value || "");
				const response = await this.$axios.post(
					`${process.env.VUE_APP_URL}/api/kpi-item/${kpi.id}`,
					formData,
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
							"Content-Type": "multipart/form-data",
						},
					}
				);

				console.log(` Auto-save berhasil untuk KPI ${kpi.id}:`, response.data);
				await new Promise((resolve) => setTimeout(resolve, 1000));
			} catch (error) {
				console.error(`❌ Error auto-saving KPI item ${kpi.id}:`, error);
				this.$emit("show-snackbar", {
					color: "error",
					icon: "mdi-alert",
					mode: "single",
					position: "top",
					text: `Gagal menyimpan ${fieldName}`,
					timeout: 3000,
					title: "Auto-save Error",
					visible: true,
				});
				await new Promise((resolve) => setTimeout(resolve, 1000));
			} finally {
				this.$store.dispatch("setOverlay", false);
			}
		},

		getUnitId(unitText) {
			if (!unitText) return null;

			const unitMap = {
				"%": 1,
				Rp: 2,
				Unit: 3,
			};
			return unitMap[unitText] || null;
		},

		getCalculationId(calcText) {
			const calcMap = {
				Sum: 1,
				Last: 4,
				Max: 3,
				Average: 2,
			};
			return calcMap[calcText] || null;
		},

		getVerticalId(verticalText) {
			const verticalMap = {
				Sum: 1,
				Average: 2,
			};
			return verticalMap[verticalText] || null;
		},

		beforeDestroy() {
			if (this.autoSaveTimeout) {
				clearTimeout(this.autoSaveTimeout);
			}
		},

		validateAndOpenSubDetail() {
			if (this.calculateTotalBobot !== 100) {
				this.$emit("show-snackbar", {
					color: "error",
					icon: "mdi-alert",
					mode: "single",
					position: "top",
					text: "Total Bobot harus tepat 100 untuk melanjutkan",
					timeout: 7500,
					title: "Error",
					visible: true,
				});
				return;
			}
			const kpiPeriodeId = this.activePeriod?.id || this.selectedNode?.id;
			const chartId = this.selectedNode?.id;

			if (kpiPeriodeId) {
				this.$router.push({
					name: "subdetail",
					params: {
						kpiPeriodeId: kpiPeriodeId,
						chartId: chartId,
					},
				});
			}
		},

		async fetchKpiItemData(chartId) {
			try {
				this.hasUserInteraction = false;
				this.isInitialLoading = true;
				const response = await this.$axios.get(
					`${process.env.VUE_APP_URL}/api/kpi-item/${chartId}`,
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
							"Content-Type": "application/json",
						},
					}
				);

				if (response.data && Array.isArray(response.data)) {
					response.data.forEach((kpi) => {
						if (kpi.shares && kpi.shares.length > 0) {
							if (!kpi.ownerSets) kpi.ownerSets = [{}];
							kpi.ownerSets[0].sharing = kpi.shares.map((share) => ({
								text: this.getSharingText(share.chart_id),
								value: share.chart_id,
							}));
						}
					});
				}

				await Promise.all([
					this.fetchOwnerData(chartId),
					this.loadSharingOptions(chartId),
				]);

				this.$nextTick(() => {
					const isNewItem = this.$route.query.newItem === "true";

					this.changedItems = [];

					if (isNewItem) {
						this.hasUserInteraction = true;

						const kpiDataArray = response.data.items || response.data || [];
						kpiDataArray.forEach((kpi) => {
							if (kpi.id && !this.changedItems.includes(kpi.id)) {
								this.changedItems.push(kpi.id);
							}
						});
					} else {
						const kpiDataArray = response.data.items || response.data || [];
						const hasEmptyKpiName = kpiDataArray.some(
							(kpi) =>
								!kpi.kpi_name || kpi.kpi_name === "" || kpi.kpi_name === null
						);

						if (hasEmptyKpiName) {
							this.hasUserInteraction = true;
							kpiDataArray.forEach((kpi) => {
								if (kpi.id && !this.changedItems.includes(kpi.id)) {
									this.changedItems.push(kpi.id);
								}
							});
						} else {
							this.hasUserInteraction = false;
						}
					}

					this.isInitialLoading = false;
				});

				this.$emit("kpi-item-data-loaded", {
					kpiData: response.data.items || response.data,
					formattedOwners: this.formattedOwners,
					formattedSharingOptions: this.formattedSharingOptions,
				});
			} catch (error) {
				this.$emit("show-snackbar", {
					color: "error",
					icon: "mdi-alert-circle",
					timeout: 5000,
					title: "Error",
					text: error.message || "Failed to fetch KPI data",
				});
			}
		},

		async fetchOwnerData(chartId) {
			try {
				const response = await this.$axios.get(
					`${process.env.VUE_APP_URL}/api/kpi-item/owner/${chartId}`,
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
							"Content-Type": "application/json",
						},
					}
				);
				this.apiOwners = response.data || [];
				this.formattedOwners = this.apiOwners.map((owner) => ({
					text: `${owner.position_name} - ${owner.name}`,
					value: owner.id,
				}));
			} catch (error) {
				this.$emit("show-snackbar", {
					color: "error",
					icon: "mdi-alert-circle",
					timeout: 5000,
					title: "Error",
					text: error.message || "Failed to fetch owner data",
				});
			}
		},

		async loadSharingOptions(chartId) {
			try {
				if (!chartId) {
					console.warn("Chart ID tidak tersedia untuk load sharing options");
					return;
				}
				const response = await this.$axios.get(
					`${process.env.VUE_APP_URL}/api/kpi-item/sharing/${chartId}`,
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
							"Content-Type": "application/json",
						},
					}
				);

				this.apiSharingOptions = response.data || [];
				this.apiSharingOptions = this.apiSharingOptions.filter((sharing) => {
					const sharingChartId = sharing.chart_id || sharing.id;
					return (
						sharingChartId != chartId && sharingChartId !== parseInt(chartId)
					);
				});
				this.formattedSharingOptions = this.apiSharingOptions.map(
					(sharing) => ({
						text: `${sharing.position_name} - ${sharing.name}`,
						value: sharing.chart_id || sharing.id,
					})
				);
			} catch (error) {
				console.error("❌ Error loading sharing options:", error);
				this.formattedSharingOptions = [];
			}
		},

		getMonthIndex(monthName) {
			const months = [
				"January",
				"February",
				"March",
				"April",
				"May",
				"June",
				"July",
				"August",
				"September",
				"October",
				"November",
				"December",
			];
			return months.findIndex(
				(month) => month.toLowerCase() === monthName.toLowerCase()
			);
		},

		async addOwnerSetLocal(kpiIndex) {
			this.$store.dispatch("setOverlay", true);
			const parentKpi = this.kpiData[kpiIndex];
			if (!parentKpi) {
				console.error("Parent KPI tidak ditemukan");
				return;
			}
			try {
				const childKpiName = parentKpi.kpiName;
				const parentHigherLower = parentKpi.ownerSets[0].higherLower;
				const parentPengukuran = parentKpi.ownerSets[0].pengukuran;
				const parentSumber = parentKpi.ownerSets[0].sumberData;

				const payload = {
					parent_id: parseInt(parentKpi.id),
					chart_id: parentKpi.chart_id,
					kpi_periode_id: parentKpi.kpi_periode_id,
					kpi_name: childKpiName,
					unit_id: null,
					kalkulasi_id: null,
					bobot: null,
					manual_adjustment: false,
					owner_id: null,
					sharing_id: null,
					pengukuran: parentPengukuran,
					sumberData: parentSumber,
					annual_target: null,
					direction: parentHigherLower,
				};

				const response = await this.$axios.post(
					`${process.env.VUE_APP_URL}/api/kpi-item`,
					payload,
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
							"Content-Type": "application/json",
						},
					}
				);
				await new Promise((resolve) => setTimeout(resolve, 3000));
				const newOwnerSet = {
					id: response.data.id,
					kpi_item_id: response.data.id,
					checked: false,
					kpiName: response.data.kpi_name || childKpiName,
					owner: null,
					sharing: null,
					pengukuran: parentPengukuran,
					sumberData: parentSumber,
					unit: null,
					kalkulasi: null,
					vertikal: null,
					bobot: null,
					annualTarget: null,
					higherLower: parentHigherLower,
					hasChanges: false,
					isNew: true,
				};
				if (!parentKpi.ownerSets) {
					this.$set(parentKpi, "ownerSets", [parentKpi.ownerSets[0]]);
				}
				parentKpi.ownerSets.push(newOwnerSet);

				const newChildKpi = {
					id: response.data.id,
					kpi_periode_id: response.data.kpi_periode_id,
					chart_id: response.data.chart_id,
					manualAdjustment: response.data.manual_adjustment || false,
					kpiName: response.data.kpi_name,
					unit: this.getUnitText(response.data.unit_id),
					kalkulasi: this.getCalculationText(response.data.kalkulasi_id),
					vertikal: this.getVerticalText(response.data.vertical_id),
					bobot: response.data.bobot || "",
					ownerSets: [
						{
							kpi_item_id: response.data.id,
							owner: response.data.owner_id || "",
							sharing: response.data.sharing_id || "",
							pengukuran: parentPengukuran,
							kpiName: response.data.kpi_name || "",
							sumberData: parentSumber,
							unit: response.data.unit_id,
							kalkulasi: response.data.kalkulasi_id,
							vertikal: response.data.vertical_id,
							bobot: response.data.bobot || "",
							annualTarget: response.data.annual_target || "",
							higherLower: parentHigherLower,
							checked: false,
							hasChanges: false,
						},
					],
				};
				this.$emit("add-child-kpi", newChildKpi);

				this.$emit("show-snackbar", {
					color: "success",
					icon: "mdi-check-circle",
					timeout: 3000,
					title: "Berhasil",
					text: "Child KPI berhasil ditambahkan dan memiliki child",
				});
				if (this.changedItems && this.changedItems.length > 0) {
					try {
						await this.batchSaveKpiData();
					} catch (e) {
						this.$emit("show-snackbar", {
							color: "warning",
							icon: "mdi-alert",
							timeout: 3000,
							title: "Peringatan",
							text: "Auto-save gagal, reload tetap dilanjutkan",
						});
					}
				}

				const chartId = this.selectedNode?.id;
				const kpiPeriodeId = this.activePeriod?.id || this.selectedPeriod?.id;

				await this.$nextTick();
				await new Promise((r) => setTimeout(r, 100));

				await this.$router.replace({
					query: {
						chartId,
						kpiPeriodeId,
						openDetail: "true",
						newItem: "true",
					},
				});

				this.$store.dispatch("setOverlay", false);
				window.location.reload();
				window.scrollTo({
					top: Math.max(
						0,
						(document.body.scrollHeight - window.innerHeight) / 2
					),
					behavior: "smooth",
				});
			} catch (error) {
				console.error("❌ Error menambahkan child KPI:", error);
				this.$emit("show-snackbar", {
					color: "error",
					icon: "mdi-alert-circle",
					timeout: 5000,
					title: "Error",
					text: "Gagal menambah child KPI",
				});
			} finally {
				this.$store.dispatch("setOverlay", false);
			}
		},

		removeOwnerSetLocal({ kpiIndex, ownerSetIndex }) {
			if (kpiIndex < 0 || ownerSetIndex <= 0) {
				return;
			}

			const kpi = this.kpiData[kpiIndex];
			if (!kpi || !kpi.ownerSets || kpi.ownerSets.length <= ownerSetIndex) {
				return;
			}

			const ownerSetToRemove = kpi.ownerSets[ownerSetIndex];

			this.deleteOwnerSetData = {
				kpiIndex,
				ownerSetIndex,
				kpiName: kpi.kpiName,
				kpiItemId: ownerSetToRemove.kpi_item_id,
			};

			this.deleteConfirmDialog = true;
		},

		confirmDeleteOwnerSet() {
			if (!this.deleteOwnerSetData) return;

			const { kpiIndex, ownerSetIndex, kpiItemId } = this.deleteOwnerSetData;

			this.$emit("remove-owner-set", {
				kpiIndex,
				ownerSetIndex,
				kpiItemId,
			});

			this.$emit("show-snackbar", {
				color: "success",
				icon: "mdi-check-circle",
				timeout: 3000,
				title: "Berhasil",
				text: "Child berhasil dihapus",
			});

			this.deleteOwnerSetData = null;
			this.deleteConfirmDialog = false;
		},

		cancelDeleteOwnerSet() {
			this.deleteOwnerSetData = null;
			this.deleteConfirmDialog = false;
		},

		removeallkpi(kpiIndex) {
			this.$emit("remove-all-kpi", kpiIndex);
		},

		getUnitText(unitId) {
			const unitMap = {
				1: "%",
				2: "Rp",
				3: "Unit",
			};
			return unitMap[unitId] || "";
		},

		getCalculationText(calculationId) {
			const calcMap = {
				1: "Sum",
				4: "Last",
				3: "Max",
				2: "Average",
			};
			return calcMap[calculationId] || "";
		},

		emitAddKpiData() {
			this.viewMode = "add";
			this.isModalJustOpened = false;
			this.$emit("add-kpi-data");
		},

		handleUpdateKpiData(freshKpiData) {
			this.$emit("update-kpi-data", freshKpiData);
		},

		handleKpiDataLoaded(data) {
			this.$emit("kpi-data-loaded", data);
		},

		calculateAnnualTarget(kpi) {
			if (kpi && kpi.status_kpi === "child-parent") {
				return;
			}

			if (this.isInitialLoading || !this.hasUserInteraction) {
				if (kpi.ownerSets && kpi.ownerSets.length > 1 && kpi.vertikal) {
					let sum = 0;

					const isSum = kpi.vertikal === "Sum" || kpi.vertikal === 1;
					const isAverage = kpi.vertikal === "Average" || kpi.vertikal === 2;

					if (isSum) {
						for (let i = 1; i < kpi.ownerSets.length; i++) {
							console.log(
								"asuu > ",
								this.normalizeNumberInput(kpi.ownerSets[i].annualTarget)
							);
							sum +=
								parseFloat(
									this.normalizeNumberInput(kpi.ownerSets[i].annualTarget)
								) || 0;
						}
					} else if (isAverage) {
						for (let i = 1; i < kpi.ownerSets.length; i++) {
							sum +=
								parseFloat(
									this.normalizeNumberInput(kpi.ownerSets[i].annualTarget)
								) || 0;
						}
						sum = sum / (kpi.ownerSets.length - 1);
					}

					this.$set(kpi.ownerSets[0], "annualTarget", sum);
				}
				return;
			}

			const isManualAdjustment =
				kpi.manualAdjustment === true ||
				(kpi.ownerSets &&
					kpi.ownerSets[0] &&
					kpi.ownerSets[0].checked === true) ||
				(kpi.ownerSets &&
					kpi.ownerSets[0] &&
					kpi.ownerSets[0].manual_adjustment === true);
			if (isManualAdjustment) {
				kpi.vertikal = "";
				if (kpi.ownerSets && kpi.ownerSets[0]) {
					kpi.ownerSets[0].vertikal = "";
				}
			}

			if (kpi.ownerSets && kpi.ownerSets.length > 1 && kpi.vertikal) {
				let sum = 0;
				const isSum = kpi.vertikal === "Sum" || kpi.vertikal === 1;
				const isAverage = kpi.vertikal === "Average" || kpi.vertikal === 4;

				if (isSum) {
					for (let i = 1; i < kpi.ownerSets.length; i++) {
						sum +=
							parseFloat(
								this.normalizeNumberInput(kpi.ownerSets[i].annualTarget)
							) || 0;
					}
				} else if (isAverage) {
					for (let i = 1; i < kpi.ownerSets.length; i++) {
						sum +=
							parseFloat(
								this.normalizeNumberInput(kpi.ownerSets[i].annualTarget)
							) || 0;
					}
					sum = sum / (kpi.ownerSets.length - 1);
				}

				this.$set(kpi.ownerSets[0], "annualTarget", sum);
				this.trackChanges(kpi, "annual_target", sum);
			}
		},

		onOwnerSetAnnualTargetChange(kpiIndex, ownerSetIndex, value) {
			this.hasUserInteraction = true;

			console.log("🔥 onOwnerSetAnnualTargetChange called:", {
				kpiIndex,
				ownerSetIndex,
				value,
				hasUserInteraction: this.hasUserInteraction,
				changedItemsBefore: Array.from(this.changedItems),
			});

			if (
				this.kpiData[kpiIndex] &&
				this.kpiData[kpiIndex].ownerSets[ownerSetIndex]
			) {
				this.$set(
					this.kpiData[kpiIndex].ownerSets[ownerSetIndex],
					"annualTarget",
					value
				);
			}

			const kpi = this.kpiData[kpiIndex];
			const ownerSet = kpi.ownerSets[ownerSetIndex];

			if (
				ownerSet &&
				ownerSet.kpi_item_id &&
				!this.changedItems.includes(ownerSet.kpi_item_id)
			) {
				this.changedItems.push(ownerSet.kpi_item_id);
			}

			if (kpi.id && !this.changedItems.includes(kpi.id)) {
				this.changedItems.push(kpi.id);
			}
			const isManualAdjustment =
				kpi.manualAdjustment === true ||
				(kpi.ownerSets &&
					kpi.ownerSets[0] &&
					kpi.ownerSets[0].checked === true) ||
				(kpi.ownerSets &&
					kpi.ownerSets[0] &&
					kpi.ownerSets[0].manual_adjustment === true);

			if (isManualAdjustment) {
				console.log(
					`⚡ Manual adjustment aktif untuk KPI "${kpi.kpiName}" - TIDAK menghitung ulang annual target dari bawah ke atas!`
				);
				return;
			}
			this.calculateAnnualTarget(this.kpiData[kpiIndex]);

			console.log("🔥 onOwnerSetAnnualTargetChange result:", {
				changedItemsAfter: Array.from(this.changedItems),
				changedItemsCount: this.changedItemsCount,
			});
		},

		async deleteKpiItemFromOwnerSet(kpiIndex, ownerSetIndex) {
			const ownerSet = this.kpiData[kpiIndex]?.ownerSets[ownerSetIndex];
			if (!ownerSet || !ownerSet.kpi_item_id) {
				console.error("Invalid ownerSet or missing kpi_item_id");
				return;
			}

			await this.deleteKpiItem(ownerSet.kpi_item_id);

			this.removeOwnerSetLocal({ kpiIndex, ownerSetIndex });
		},

		getVerticalText(verticalId) {
			const verticalMap = {
				1: "Sum",
				2: "Average",
			};
			return verticalMap[verticalId] || "";
		},

		getSharingName(item) {
			if (typeof item === "object" && item.text) {
				return item.text;
			}
			const sharing = this.formattedSharingOptions.find(
				(s) => s.value === item
			);
			return sharing ? sharing.text : item;
		},

		removeChip(kpi, item) {
			const sharing = kpi.ownerSets[0].sharing;
			const itemIndex = sharing.findIndex(
				(s) =>
					(typeof s === "object" ? s.value : s) ===
					(typeof item === "object" ? item.value : item)
			);
			if (itemIndex > -1) {
				sharing.splice(itemIndex, 1);
				this.trackChanges(kpi, "sharing", sharing);
			}
		},

		getSharingNameChild(item) {
			if (typeof item === "object" && item.text) {
				return item.text;
			}
			const sharing = this.formattedSharingOptions.find(
				(s) => s.value === item
			);
			return sharing ? sharing.text : item;
		},

		removeChildChip(kpi, item, chipIndex, ownerSetIndex) {
			const sharing = kpi.ownerSets[ownerSetIndex].sharing;
			const itemIndex = sharing.findIndex(
				(s) =>
					(typeof s === "object" ? s.value : s) ===
					(typeof item === "object" ? item.value : item)
			);
			if (itemIndex > -1) {
				sharing.splice(itemIndex, 1);

				if (ownerSetIndex === 0) {
					this.trackChanges(kpi, "sharing", sharing);
				} else {
					this.trackOwnerSetChanges(kpi, ownerSetIndex, "sharing_id", sharing);
				}
			}
		},

		async batchSaveKpiData() {
			this.$store.dispatch("setOverlay", true);
			if (this.changedItems.length === 0) {
				this.$emit("show-snackbar", {
					color: "info",
					icon: "mdi-information",
					timeout: 3000,
					title: "Info",
					text: "Tidak ada perubahan untuk disimpan",
				});
				this.$store.dispatch("setOverlay", false);
				return;
			}

			try {
				this.isSaving = true;
				this.$store.dispatch("setOverlay", true);

				let chart_id = this.selectedNode?.id;
				if (!chart_id) {
					const fallbackChartId = this.kpiData[0]?.chart_id;
					if (!fallbackChartId) {
						throw new Error("Chart ID tidak ditemukan");
					}
					chart_id = fallbackChartId;
				}

				let batchData = [];
				this.kpiData.forEach((kpi) => {
					if (this.changedItems.includes(kpi.id)) {
						const kpiItemData = {
							id: kpi.id,
							manual_adjustment: kpi.manualAdjustment,
							is_accounting: kpi.is_accounting,
							kpi_name: kpi.kpiName,
							kalkulasi_id: this.getCalculationId(kpi.kalkulasi),
							vertical_id: this.getVerticalId(kpi.vertikal),
							bobot: kpi.bobot,
							pengukuran: kpi.ownerSets[0].pengukuran,
							sumber_data: kpi.ownerSets[0].sumberData,
							annual_target: this.normalizeNumberInput(
								kpi.ownerSets[0].annualTarget
							),
							direction: kpi.ownerSets[0].higherLower,
						};

						if (kpi.ownerSets[0].owner) {
							kpiItemData.owner_id = kpi.ownerSets[0].owner;
						}

						if (kpi.unit) {
							kpiItemData.unit_id = this.getUnitId(kpi.unit);
						}

						if (
							kpi.ownerSets[0].sharing &&
							kpi.ownerSets[0].sharing.length > 0
						) {
							kpiItemData.shares = kpi.ownerSets[0].sharing.map((share) => ({
								chart_id: share.value || share.id || share,
							}));
						} else {
							kpiItemData.shares = [];
						}
						batchData.push(kpiItemData);

						if (kpi.ownerSets && kpi.ownerSets.length > 1) {
							for (let i = 1; i < kpi.ownerSets.length; i++) {
								const childOwnerSet = kpi.ownerSets[i];
								if (childOwnerSet.kpi_item_id) {
									const childData = {
										id: childOwnerSet.kpi_item_id,
										annual_target: this.normalizeNumberInput(
											childOwnerSet.annualTarget
										),
									};

									if (childOwnerSet.owner) {
										childData.owner_id = childOwnerSet.owner;
									}
									if (
										childOwnerSet.sharing &&
										childOwnerSet.sharing.length > 0
									) {
										childData.shares = childOwnerSet.sharing.map((share) => ({
											chart_id: share.value || share.id || share,
										}));
									} else {
										childData.shares = [];
									}

									batchData.push(childData);
								}
							}
						}
					}
				});

				await this.$axios.post(
					`${process.env.VUE_APP_URL}/api/kpi-item/batch/update`,
					{
						chart_id: chart_id,
						items: batchData,
					},
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
							"Content-Type": "application/json",
						},
					}
				);
				await new Promise((resolve) => setTimeout(resolve, 2000));
				this.changedItems = [];
				this.isModalJustOpened = false;
				this.$emit("show-snackbar", {
					color: "success",
					icon: "mdi-check-circle",
					timeout: 3000,
					title: "Berhasil",
					text: `${batchData.length} KPI item berhasil disimpan`,
				});
			} catch (error) {
				console.error("Error batch saving KPI data:", error);

				this.$emit("show-snackbar", {
					color: "error",
					icon: "mdi-alert-circle",
					timeout: 5000,
					title: "Error",
					text: error.response?.data?.message || "Gagal menyimpan data KPI",
				});
			} finally {
				this.isSaving = false;
				this.$store.dispatch("setOverlay", false);
			}
		},

		getSharingText(chartId) {
			const option = this.formattedSharingOptions.find(
				(opt) => opt.value === chartId
			);
			return option ? option.text : `Chart ID: ${chartId}`;
		},

		isSharedKpi(kpi) {
			return kpi.status_kpi === "shared";
		},

		isOwned(kpi) {
			return kpi.status_kpi === "owned";
		},

		parentDisabled(kpi) {
			return kpi.status_kpi === "parent";
		},

		isFieldDisabledForShared(kpi, fieldName) {
			if (this.isSharedKpi(kpi)) {
				return fieldName !== "annual_target";
			}
			return false;
		},

		isNewItem(kpi) {
			return !kpi.status_kpi || kpi.status_kpi === "new";
		},

		getSharedOwnerDisplay(kpi) {
			if (kpi.owner_position_name && kpi.owner_name) {
				const result = `${kpi.owner_position_name} - ${kpi.owner_name}`;
				return result;
			}
			const fallback =
				kpi.owner_position_name || kpi.owner_name || "Shared Owner";
			return fallback;
		},

		isParent(kpi) {
			const isManualAdjustment =
				kpi.manualAdjustment === true ||
				(kpi.ownerSets &&
					kpi.ownerSets[0] &&
					kpi.ownerSets[0].checked === true) ||
				(kpi.ownerSets &&
					kpi.ownerSets[0] &&
					kpi.ownerSets[0].manual_adjustment === true);

			if (isManualAdjustment) {
				return false;
			}

			return kpi.status_kpi === "parent";
		},

		isDisabledChildDisplay(kpi) {
			return kpi.status_kpi === "child";
		},

		getSharingDisplayText(kpi) {
			if (this.isSharedKpi(kpi) && kpi.shares && kpi.shares.length > 0) {
				return kpi.shares
					.map((share) => {
						const option = this.apiSharingOptions.find(
							(opt) => opt.id === share.chart_id
						);
						if (option) {
							return `${option.position_name} - ${option.name}`;
						}
						return `Chart ID: ${share.chart_id}`;
					})
					.join(", ");
			}

			if (kpi.ownerSets && kpi.ownerSets[0] && kpi.ownerSets[0].sharing) {
				const sharing = kpi.ownerSets[0].sharing;

				if (Array.isArray(sharing) && sharing.length > 0) {
					return sharing
						.map((item) => {
							if (typeof item === "object" && item.text) {
								return item.text;
							}
							return this.getSharingText(item);
						})
						.join(", ");
				}

				if (typeof sharing === "object" && sharing.text) {
					return sharing.text;
				}

				return this.getSharingText(sharing);
			}

			return "No sharing data";
		},
	},
	watch: {
		value(val) {
			if (val) {
				this.isModalJustOpened = true;
			}
		},
		selectedNode: {
			handler(newNode) {
				if (newNode && newNode.id) {
					this.fetchKpiItemData(newNode.id);
					this.loadSharingOptions(newNode.id);
				}
			},
			immediate: true,
		},
		dialogdetailuser: {
			handler(isOpen) {
				if (isOpen && this.selectedNode && this.selectedNode.id) {
					this.fetchKpiItemData(this.selectedNode.id);
				}
			},
		},
		kpiData: {
			handler(newVal) {
				if (newVal && newVal.length > 0) {
					newVal.forEach((kpi) => {
						this.calculateAnnualTarget(kpi);
					});
				}
			},
			deep: true,
		},
	},
};
</script>

<style scoped>
/* KPI Header Card Styles */
.kpi-header-card {
	border-radius: 8px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	background: white;
	border: 1px solid #e5e7eb;
	overflow: hidden;
}

.kpi-header-gradient {
	background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
	padding: 16px 24px;
}

.kpi-header-title {
	font-size: 20px;
	font-weight: 700;
	color: white;
	margin: 0;
	display: flex;
	align-items: center;
}

.kpi-header-body {
	padding: 20px 24px;
}

.kpi-header-card-simplified {
	padding: 12px 16px;
	background-color: #f5f5f5;
	border-radius: 8px;
	border-left: 4px solid #1976d2;
	flex: 1;
	margin-right: 16px;
}

.kpi-prepared-label-simplified {
	font-size: 13px;
	font-weight: 600;
	color: #1976d2;
	text-transform: uppercase;
	letter-spacing: 0.5px;
}

.kpi-info-value-simplified {
	font-size: 14px;
	color: #111827;
	font-weight: 500;
}

.kpi-avatar-wrapper {
	flex-shrink: 0;
	margin-right: 16px;
}

.kpi-avatar-circle {
	width: 48px;
	height: 48px;
	border-radius: 50%;
	background-color: #e3f2fd;
	display: flex;
	align-items: center;
	justify-content: center;
}

.kpi-prepared-label {
	font-size: 12px;
	font-weight: 600;
	color: #1976d2;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	margin-bottom: 12px;
}

.kpi-info-list {
	display: flex;
	flex-direction: column;
}

.kpi-info-label {
	font-size: 14px;
	color: #6b7280;
	font-weight: 500;
	min-width: 100px;
}

.kpi-info-value {
	font-size: 16px;
	color: #111827;
	font-weight: 600;
	margin-left: 12px;
}

.kpi-note-text {
	font-size: 14px;
	color: #6b7280;
	font-style: italic;
}

.kpi-add-btn {
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
	transition: box-shadow 0.2s ease;
}

.kpi-add-btn:hover {
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}

.table-input-small .v-select,
.table-input-small .v-text-field {
	max-width: 250px;
}
.kpi-table >>> tbody td {
	padding: 4px !important;
	vertical-align: top !important;
	border-bottom: 1px solid rgba(0, 0, 0, 0.12);
	text-align: center;
	min-height: 48px !important;
	display: table-cell !important;
	position: relative;
	overflow: visible;
}
.input-center {
	width: 95%;
	margin: 0 auto !important;
	display: flex !important;
	align-items: center !important;
	min-height: 40px !important;
}

.checkbox-center {
	margin: 0 auto !important;
	justify-content: center !important;
	display: flex !important;
	align-items: center !important;
	height: 100% !important;
}

/* Perbaikan untuk baris tambahan */
.additional-row td {
	padding: 4px !important;
	border-top: none !important;
	height: 48px !important;
	vertical-align: middle !important;
	display: table-cell !important;
}

.additional-row .input-center,
.additional-row .checkbox-center {
	margin: 0 auto !important;
	height: 100% !important;
}

/* Perbaikan untuk input slots */
.v-text-field >>> .v-input__slot,
.v-select >>> .v-input__slot {
	min-height: 32px !important;
	margin: 0 !important;
	display: flex !important;
	align-items: center !important;
}

/* Hapus margin-top yang tidak konsisten */
.additional-row .v-input__slot,
.additional-row .v-text-field >>> .v-input__slot,
.additional-row .v-select >>> .v-input__slot,
.additional-row .checkbox-center,
.additional-row .v-btn {
	margin-top: 0 !important;
}
.kpi-table-container {
	/* max-height: 300px; */
	overflow: auto;
	border: 2px solid #e0e0e0;
	border-radius: 8px;
	position: relative;
	background-color: #ffffff;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08);
	transition: box-shadow 0.3s ease;
}

.kpi-table-container:hover {
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Scrollbar styling untuk container */
.kpi-table-container::-webkit-scrollbar {
	width: 8px;
	height: 8px;
}

.kpi-table-container::-webkit-scrollbar-track {
	background: #f5f5f5;
	border-radius: 4px;
}

.kpi-table-container::-webkit-scrollbar-thumb {
	background: #bdbdbd;
	border-radius: 4px;
}

.kpi-table-container::-webkit-scrollbar-thumb:hover {
	background: #9e9e9e;
}

/* Table min-width agar body scroll horizontal saat konten lebar */
.kpi-table >>> table {
	min-width: max-content;
}

/* Header freeze di atas saat scroll vertikal */
.kpi-table >>> thead {
	position: sticky;
	top: 0;
	z-index: 10;
}

.kpi-table >>> thead th {
	background-color: #003871 !important;
	color: white;
	font-weight: 600;
	padding: 12px 8px;
	text-transform: uppercase;
	font-size: 0.875rem;
	white-space: nowrap;
	position: sticky;
	top: 0;
	z-index: 10;
	text-align: center;
	height: 48px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.input-align-center >>> .v-input__control {
	display: flex !important;
	align-items: center !important;
	height: 40px !important;
}

.input-align-center >>> input {
	margin-top: 4px !important;
}
.sticky-footer {
	position: sticky;
	bottom: 0;
	background: white;
	z-index: 10;
}
.action-buttons {
	width: 80px !important;
	min-width: 80px !important;
	padding: 4px !important;
}

.action-buttons .d-flex {
	height: 40px;
	min-height: 40px;
}

.action-buttons .v-btn {
	width: 32px !important;
	height: 32px !important;
	min-width: 32px !important;
}

.action-buttons .v-btn .v-icon {
	font-size: 18px !important;
}
.disabled-text-field {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 40px;
	background-color: #f5f5f5;
	border: 1px solid #e0e0e0;
	border-radius: 4px;
	color: #9e9e9e;
	font-size: 14px;
	font-style: italic;
}
.text-caption {
	font-size: 12px;
	color: #6b7280;
}
.text-caption-red {
	font-size: 12px;
	color: #ff0000;
}

/* Error message styling */
.merged-cell .v-textarea {
	margin-bottom: 0 !important;
}

.merged-cell .v-textarea >>> .v-input__control {
	margin-bottom: 0 !important;
}

.error-message-wrapper {
	display: flex;
	align-items: center;
	margin-top: 4px;
	padding: 4px 8px;
	background-color: #ffebee;
	border-left: 3px solid #f44336;
	border-radius: 4px;
	animation: fadeIn 0.2s ease-in;
	width: calc(100% - 8px);
	max-width: calc(100% - 8px);
	box-sizing: border-box;
	font-size: 11px;
	line-height: 1.3;
	margin-left: auto;
	margin-right: auto;
}

.error-message-text {
	font-size: 11px;
	color: #c62828;
	font-weight: 500;
	line-height: 1.3;
}

@keyframes fadeIn {
	from {
		opacity: 0;
		transform: translateY(-4px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

/* Responsive untuk Prepared by card dan button */
@media (max-width: 960px) {
	.kpi-header-card-simplified {
		margin-right: 8px;
		padding: 10px 12px;
	}

	.kpi-prepared-label-simplified {
		font-size: 11px;
	}

	.kpi-info-value-simplified {
		font-size: 12px;
	}
}
</style>